import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth, roleHome } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

function Loading() {
  return (
    <div className="flex h-screen items-center justify-center bg-white">
      <Loader2 className="h-8 w-8 animate-spin text-[#0F52BA]" />
    </div>
  );
}

export function ProtectedRoute({ children, requireRole = null }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/login" replace />;
  if (requireRole) {
    const roles = Array.isArray(requireRole) ? requireRole : [requireRole];
    if (!roles.includes(user.role)) return <Navigate to={roleHome(user)} replace />;
  }
  return children;
}
